<template>
  <!-- Wrapper to handle many different Monument fields -->
  <div
    class="monument-field"
    v-if="containsText(returnValueInLanguage(language, details)[field])"
  >
    <span
      class="monument-field-label"
      v-if="
        label === 'Directions' ||
        label === 'How to Reach' ||
        label === 'Info' ||
        label === 'Contact'
      "
      >{{ label.toUpperCase() }}<br
    /></span>
    <span class="monument-field-label" v-else>{{ label }}: </span>
    <span
      v-if="field !== 'responsibleInstitution'"
      v-html="returnValueInLanguage(language, details)[field]"
    >
    </span>
    <!-- Responsible Institution has different fields but all belong under one section -->
    <span v-else class="responsible-institution-fields">
      <span v-if="containsText(returnValueInLanguage(language, details)[field].name)">
        Name: {{ returnValueInLanguage(language, details)[field].name }}
      </span>
      <span v-if="containsText(returnValueInLanguage(language, details)[field].address)">
        Address: {{ returnValueInLanguage(language, details)[field].address }}
      </span>
      <span v-if="containsText(returnValueInLanguage(language, details)[field].tel)">
        Telephone: {{ returnValueInLanguage(language, details)[field].tel }}
      </span>
      <span v-if="containsText(returnValueInLanguage(language, details)[field].fax)">
        Fax: {{ returnValueInLanguage(language, details)[field].fax }}
      </span>
      <span v-if="containsText(returnValueInLanguage(language, details)[field].email)">
        Email: {{ returnValueInLanguage(language, details)[field].email }}
      </span>
      <span v-if="containsText(returnValueInLanguage(language, details)[field].website)">
        Website: {{ returnValueInLanguage(language, details)[field].website }}
      </span>
    </span>
  </div>
</template>

<script>
import truncate from "../mixins/truncate.js";
import language from "../mixins/language.js";
export default {
  name: "MonumentField",
  props: {
    language: String,
    details: Array,
    field: String,
    label: String,
  },
  mixins: [truncate, language],
  methods: {
    // Check if there is text entered
    containsText: function (value) {
      if (
        typeof value === "object" &&
        this.field === "responsibleInstitution"
      ) {
        let values = Object.values(
          this.returnValueInLanguage("en", this.details)[this.field]
        );
        let text = false;
        for (let i = 0; i < values.length; i++) {
          if (values[i] && values[i].length > 0) {
            text = true;
            break;
          }
        }
        if (text) {
          return true;
        } else {
          return false;
        }
      } else if (value && value.length > 0) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.monument-field {
  margin-bottom: 20px;
}
.monument-field :deep(*) {
  @include texts;
  @include font-size-6;
}
.monument-field :deep(a) {
  @include link-styles;
}
.monument-field :deep(a:hover) {
  @include link-hover-styles;
}

.monument-field-label {
  display: block;
  margin-bottom: 10px;
}
.location-contact .monument-field .monument-field-label {
  display: inline;
}

.responsible-institution-fields {
  display: flex;
  flex-direction: column;
}
</style>
